slashedProtocol